import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { MessageService, FormsUtilsService, notCloseMessageOptions } from '../../../../../core';
import { ClienteAnaliseMercadoLancamentoClassificacaoCreate } from './cliente-analise-mercado-lancamento-classificacao-create';
import { GrupoClassificacaoClassificacao } from '../../../../grupo-classificacao/classificacao';
import { GrupoClassificacaoSelectComponent } from '../../../../grupo-classificacao/select';
import { GrupoClassificacaoClassificavelFormComponent } from '../../../../grupo-classificacao/classificavel/form';

@Component({
    selector: 'sgt-cliente-analise-mercado-lancamento-classificacao-create',
    templateUrl: './cliente-analise-mercado-lancamento-classificacao-create.component.html',
    styleUrls: ['./cliente-analise-mercado-lancamento-classificacao-create.component.less']
})
export class ClienteAnaliseMercadoLancamentoClassificacaoCreateComponent {
    /** ID do grupo de classificação para ser selecionado para inserir as classificações*/
    @Input() idGrupoClassificacao: number = null;
    @Output() idGrupoClassificacaoChange = new EventEmitter<number>();
    /** Classificações */
    @Input() entitiesCreate: ClienteAnaliseMercadoLancamentoClassificacaoCreate[];
    /** Ao alterar as classificações */
    @Output() entitiesCreateChange = new EventEmitter<ClienteAnaliseMercadoLancamentoClassificacaoCreate[]>();

    @ViewChild('form') form: NgForm;
    /** Select do grupo de classificações */
    @ViewChild('grupoClassificacaoSelect') grupoClassificacaoSelect: GrupoClassificacaoSelectComponent;
    @ViewChild('formClassificacoes') formClassificacoes: GrupoClassificacaoClassificavelFormComponent;

    constructor(private messageService: MessageService,
                private formsUtilsService: FormsUtilsService) { }

    /** Seta o foco no select do grupo de classificações */
    setFocusGrupo() {
        this.grupoClassificacaoSelect?.setFocus();
    }

    /** Insere uma classificação no cliente através da classificação do grupo */
    private insertClassificacao(grupoClassificacaoClassificacao: GrupoClassificacaoClassificacao) {
        const entity = new ClienteAnaliseMercadoLancamentoClassificacaoCreate();

        // Setando as informações do grupo de classificação na entidade
        this.formClassificacoes.insertClassificacao(entity, grupoClassificacaoClassificacao);

        this.entitiesCreate.push(entity);
    }

    /** Ao alterar o grupo de classificação */
    onChangeGrupoClassificacao(idGrupoClassificacao: number) {
        this.idGrupoClassificacao = idGrupoClassificacao;
        this.idGrupoClassificacaoChange.emit(this.idGrupoClassificacao);
    }

    /** Ao selecionar o grupo e retornar as suas classificações */
    onChangeGrupoClassificacoes(grupoClassificacoes: GrupoClassificacaoClassificacao[]) {
        this.entitiesCreate = [];
        grupoClassificacoes?.forEach(grupoClassificacaoClassificacao => this.insertClassificacao(grupoClassificacaoClassificacao));

        this.entitiesCreateChange.emit(this.entitiesCreate);
    }

    /** Verifica as classificações estão válidos */
    isValid(): boolean {
        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // Grupo não selecionado
        if (!this.idGrupoClassificacao) {
            this.messageService.warning('Selecione o grupo para adicionar os segmentos neste lançamento', 'Atenção', notCloseMessageOptions);
            this.grupoClassificacaoSelect?.setFocus();
            return false;
        }

        // Nenhuma classificação
        if (!this.entitiesCreate || this.entitiesCreate.length === 0) {
            this.messageService.warning('É necessário adicionar pelo menos um item no segmento', 'Atenção', notCloseMessageOptions);
            // this.insert();
            return false;
        }

        // Form Classificações
        if (!this.formClassificacoes.isValid()) {
            return false;
        }

        // Form
        if (!this.form.valid) {
            this.messageService.warning('Preencha corretamente os itens dos segmentos', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
